/* ------------------------------------------------------- mobile navigation */
(function () {
  var burger = document.querySelector('[data-mp-burger]');
  var nav = document.querySelector('[data-mp-nav]');
  if (!burger || !nav) return;

  burger.addEventListener('click', function () {
    var open = nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // On touch screens the first tap on a parent opens its submenu rather than
  // navigating, which is what people expect from a dropdown.
  nav.querySelectorAll('.has-sub > a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (window.matchMedia('(max-width: 989px)').matches) {
        var li = a.parentElement;
        if (!li.classList.contains('is-open')) {
          e.preventDefault();
          li.classList.add('is-open');
        }
      }
    });
  });
})();


/* ------------------------------------------- language / country dropdowns */
(function () {
  var toggles = document.querySelectorAll('[data-mp-loc-toggle]');
  if (!toggles.length) return;

  function closeAll(except) {
    document.querySelectorAll('[data-mp-loc-list]').forEach(function (l) {
      if (l !== except) {
        l.hidden = true;
        var t = l.parentElement.querySelector('[data-mp-loc-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var list = btn.parentElement.querySelector('[data-mp-loc-list]');
      if (!list) return;
      var open = list.hidden;
      closeAll(list);
      list.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.addEventListener('click', function () { closeAll(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();


/* ------------------------------------------------- product gallery swap */
(function () {
  var gal = document.querySelector('[data-mp-gallery]');
  if (!gal) return;
  var main = gal.querySelector('[data-mp-gal-main]');
  var thumbs = gal.querySelectorAll('[data-mp-thumb]');
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var img = btn.querySelector('img');
      if (!img || !main) return;
      main.src = img.currentSrc || img.src;
      main.alt = btn.getAttribute('aria-label') || '';
      thumbs.forEach(function (b) { b.classList.toggle('is-on', b === btn); });
    });
  });
})();
